// Dati e media del sito Bologna NCC

export const BRAND = {
  name: "Bologna NCC",
  email: "nccbolo@gmail.com",
  phone: "+39 392 634 7387",
  phoneHref: "+393926347387",
  instagram: "nccbologna",
  instagramUrl: "https://www.instagram.com/nccbologna",
  site: "nccbolognaitalia.com",
  siteUrl: "https://nccbolognaitalia.com/",
  area: "Bologna e Provincia",
};

export const MEDIA = {
  heroBg:
    "https://images.unsplash.com/photo-1608142129869-8bc08524503a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXIlMjBkcml2aW5nJTIwY2l0eSUyMG5pZ2h0fGVufDB8fHx8MTc4MTU1OTExN3ww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "aeroporti",
    title: "Transfer Aeroporti e Stazioni",
    desc: "Trasferimenti puntuali da e per aeroporti e stazioni, con monitoraggio del volo e accoglienza dedicata.",
    img: "https://images.unsplash.com/photo-1741835906792-eb13a54af7d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGFpcnBvcnQlMjB0ZXJtaW5hbHxlbnwwfHx8fDE3ODE1NTkxMTd8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    id: "motorvalley",
    title: "Motor Valley Tour",
    desc: "Esperienze esclusive nei musei Ferrari, Lamborghini e Pagani. Il cuore della terra dei motori.",
    img: "https://images.unsplash.com/photo-1614200187524-dc4b892acf16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxmZXJyYXJpJTIwcmVkJTIwc3BvcnRzJTIwY2FyfGVufDB8fHx8MTc4MTU1OTExN3ww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-5 md:row-span-2",
  },
  {
    id: "shopping",
    title: "Shopping Tour",
    desc: "Tour dedicati tra le migliori boutique e outlet della regione.",
    img: "https://images.unsplash.com/photo-1596892003083-4280deaf4275?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzaG9wcGluZyUyMGJhZ3MlMjBlbGVnYW50fGVufDB8fHx8MTc4MTU1OTExN3ww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-4",
  },
  {
    id: "gastronomia",
    title: "Tour Gastronomici",
    desc: "Alla scoperta dei sapori dell'Emilia: tortellini, mortadella, Parmigiano e aceto balsamico, con guida disponibile nella tua lingua.",
    img: "https://images.unsplash.com/photo-1663841364137-d60791e2c1d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "md:col-span-4",
  },
  {
    id: "eventi",
    title: "Transfer su Misura per Eventi",
    desc: "Spostamenti personalizzati per business, meeting, cerimonie ed eventi privati.",
    img: "https://images.unsplash.com/photo-1666200094966-52254d810577?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxib2xvZ25hJTIwaXRhbHklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgxNTU5MTE3fDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-4",
  },
];

export const FLEET = [
  {
    name: "Mercedes Classe E",
    variant: "Berlina & Station Wagon",
    img: "/fleet-mercedes-e.jpg",
    seats: "4 passeggeri",
    luggage: "3 – 4 valigie",
    note: "L'eleganza per transfer business e privati.",
  },
  {
    name: "BMW Serie 5",
    variant: "Station Wagon",
    img: "/fleet-bmw-5-touring.jpg",
    seats: "4 passeggeri",
    luggage: "4 valigie",
    note: "Comfort sportivo e ampio bagagliaio.",
  },
  {
    name: "Mercedes Classe V",
    variant: "Minivan",
    img: "/fleet-mercedes-v.jpg",
    seats: "Fino a 7 passeggeri",
    luggage: "7+ valigie",
    note: "Ideale per gruppi, famiglie e tour.",
  },
];

export const BOLOGNA = [
  {
    img: "https://images.unsplash.com/photo-1669060292745-273178a5a381?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxib2xvZ25hJTIwaXRhbHklMjBkdWUlMjB0b3JyaXxlbnwwfHx8fDE3ODE1NjE5OTF8MA&ixlib=rb-4.1.0&q=85",
    label: "Le Due Torri",
  },
  {
    img: "https://images.unsplash.com/photo-1666200094966-52254d810577?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxwaWF6emElMjBtYWdnaW9yZSUyMGJvbG9nbmF8ZW58MHx8fHwxNzgxNTYxOTkxfDA&ixlib=rb-4.1.0&q=85",
    label: "Piazza Maggiore",
  },
  {
    img: "https://images.unsplash.com/photo-1560685925-a0d13a02750a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxwaWF6emElMjBtYWdnaW9yZSUyMGJvbG9nbmF8ZW58MHx8fHwxNzgxNTYxOTkxfDA&ixlib=rb-4.1.0&q=85",
    label: "Il Centro Storico",
  },
  {
    img: "https://images.unsplash.com/photo-1740046305708-f5f4137061fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxib2xvZ25hJTIwcG9ydGljb2VzfGVufDB8fHx8MTc4MTU2MTk5MXww&ixlib=rb-4.1.0&q=85",
    label: "I Portici",
  },
  {
    img: "https://images.unsplash.com/photo-1558477280-b16731651f21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxib2xvZ25hJTIwY2l0eXNjYXBlfGVufDB8fHx8MTc4MTU2MTk5Mnww&ixlib=rb-4.1.0&q=85",
    label: "I Tetti di Bologna",
  },
];

export const VEHICLE_OPTIONS = [
  "Mercedes Classe E",
  "Mercedes Classe E SW",
  "BMW Serie 5 SW",
  "Mercedes Classe V",
];

export const SERVICE_OPTIONS = [
  { value: "aeroporto", label: "Transfer Aeroportuale" },
  { value: "stazione", label: "Transfer Stazione" },
  { value: "shopping", label: "Shopping Tour" },
  { value: "motor-valley", label: "Motor Valley Tour" },
  { value: "gastronomico", label: "Tour Gastronomico" },
  { value: "evento", label: "Evento / Cerimonia" },
  { value: "altro", label: "Servizio su Misura" },
];
